import React, { useState, useMemo, useEffect } from "react";
import { Container } from "reactstrap";
import PurchaseOrder from "lib/Core/Backend/Controllers/PurchaseOrder";
import PurchaseOrderProcessing from 'lib/Core/Backend/Controllers/PurchaseOrderProcessing';

import Notify from "lib/Utils/Alert";

const OrderSummary = (props) => {

    const { handleClick, orders, token } = props;
    const [orderDetails, setOrderDetails] = useState([]);
    const [total, setTotal] = useState(0);
    const [loader,setLoader] = useState(true)
    const poCtl = useMemo(() => new PurchaseOrder(token), [token]);
	const PoProcessingCtl = useMemo(() => new PurchaseOrderProcessing(token), [token]);

    useEffect(() => {
        poCtl.purchaseOrderDetail(orders?.id, data => {
            if (data.error || data.errorMessage) {
                Notify(alert, 'danger', data.errorMessage ?? data.error)
            } else {
                setOrderDetails(data)
                let totalPrice = data.reduce((previousValue, currentValue) => {
                    return previousValue + currentValue.total;
                  }, 0);
                  setTotal(totalPrice)
                //   if(data?.length > 0){
                    setLoader(false)
                //   }
            }
        })
       
    }, [poCtl, orders])

const downloadCSVFunc=()=>{
    PoProcessingCtl.purchaseOrderDetailDownload(orders?.name, data => {
        if (data.error || data.errorMessage) {
            Notify(alert, 'danger', data.errorMessage ?? data.error)
        }else {
            window.location.assign(data?.downloadLink, '_blank')
        }
    })
}

    return (
        <div className="orderSummary dashboardPage">
            <Container className="mt-4" fluid>
                <h5 className='mb-3'>Summary</h5>
                <div className="card card-body table-widget">
                    <div className="table-responsive p-2">
                        <table className="table table-borderless j_add_order_table">
                            <thead>
                                <tr>
                                    <th className="border-0">Brand 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    <th className="border-0">Card Type 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    
                                    <th className="border-0">Currency 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    <th className="border-0">Fee 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    <th className="border-0">Discount 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    <th className="border-0">Qty 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    <th className="border-0">Value 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    <th className="border-0">Subtotal 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                    <th className="border-0">Total 
                                    {/* <i className="bi bi-arrow-down-up" ></i> */}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            {orderDetails?.length > 0 ? orderDetails?.map((data,index)=>{
                                return (
                                    <tr key={index}>
                                    <td>{data?.brandName}</td>
                                    <td>{data?.cardTypeName}</td>
                                     <td>{data?.currency}</td>
                                    <td>${data?.fee.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                    <td>{data?.discount.toFixed(2)}%</td>
                                    <td>{data?.quantity}</td>
                                    <td>${data?.amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                    <td>${data?.subtotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                    <td>${data?.total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                </tr>
                                );
                            })
                            :
                            loader ?
                            <tr>
                             <td colSpan={10} style={{textAlign:"center"}}>
                               <div className="spinner-border text-muted text-center"></div>
                             </td>
                           </tr>
                           :
                            <tr>
                                <td className="text-center" colSpan={10}>No order details found</td>
                            </tr>
                            }
                               
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row g-3 justify-content-between align-items-center my-4">
                    <div className="col-auto">
                        <button className="btn btn-dark" onClick={() => handleClick(false)}><i className="bi bi-caret-left"></i>Back</button>
                    </div>
                    {orders?.status == 4 &&
                    <div className="col-auto ms-auto">
                        <button className="btn btn-primaryTwo" onClick={()=> downloadCSVFunc()}><i className="bi bi-download"></i> Download CSV</button>
                    </div>
}
                    <div className="col-auto">
                        <button className="btn " style={{background:"#32D66A",color:"white"}}>Total <span className="ms-2" style={{color:"white"}}>${total.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></button>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default OrderSummary;
